import Vue from 'vue'
import Vuex from 'vuex'

// Modules
// import ecommerceStoreModule from '@/views/vuexy/apps/e-commerce/eCommerceStoreModule'
// import { vuexOidcCreateStoreModule } from 'vuex-oidc'

// import { OIDC_STORE_MODULE, oidcStoreModule } from '@/../GjirafaFront/script/auth'
import app from './app'
import appConfig from './app-config'
import verticalMenu from './vertical-menu'
// import { oidcSettings } from '../config/oidc'

// Encoder
import outputPresets from './encoder/output-presets'
import jobTemplates from './encoder/job-templates'
import jobs from './encoder/jobs'
import drm from './encoder/drm'
import liveEncoder from './encoder/live-jobs'
import encoderAnalytics from './encoder/analytics'
import liveHubs from './encoder/live-hubs'
import restreams from './encoder/restreams'

// CDN
import cdn from './cdn/distributions'
import requestPolicies from './cdn/policies/requestpolicies'
import cachePolicies from './cdn/policies/cachepolicies'
import imagePolicies from './cdn/policies/imagepolicies'
// v1
// import analytics from './cdn/analytics'
import analytics from './cdn/analytics/index'

// Captain
import projects from './captain/projects'
import roles from './captain/roles'
import organization from './captain/organizations'
import storageSettings from './captain/storage-settings'
import apiKeys from './security/api-keys'
import users from './captain/users'
import payments from './captain/payments'
import captianServices from './captain/services'

// Storage
import buckets from './storage/v1/buckets'
import bucketsCors from './storage/v1/buckets-cors'
import objects from './storage/v1/objects'
import storageKeys from './storage/v1/storage-keys'
import uploading from './storage/v1/uploading'
import lifecycle from './storage/v1/lifecycle'
import multiparts from './storage/v1/multiparts'
import storageLens from './storage/v1/lens'
// storage v2
import externalAccount from './storage/v2/externalAccount'
import accountBuckets from './storage/v2/accountBuckets'
import accountObjects from './storage/v2/accountObjects'
import accountMultiparts from './storage/v2/accountMultiparts'
import accountUploading from './storage/v2/accountUploading'
import accountLifecycle from './storage/v2/accountLifecycle'
import accountBucketsCors from './storage/v2/accountBucketsCors'
import storageLensV2 from './storage/v2/lens'
import storageAnalytics from './storage/v2/analytics'

// Databases
import databases from './databases/databases'
import nodes from './databases/nodes'

// Permissions
import permissions from './user-permissions'

// Profile
import profile from './porta/profile'

// Observability
import alerts from './observability/alerts'
import providers from './observability/providers'
import healthchecks from './observability/healthchecks'
import healthcheckLogs from './observability/healthcheck-logs'
import observability from './observability/observability'

// Compute
import compute from './compute'
import firewall from './compute/firewall'
import vpc from './compute/vpc'
import sshKeys from './security/sshKeys'

// Kubernetes
import kyubi from './kyubi'
import deployments from './kyubi/deployments'
import ingress from './kyubi/ingress'
import pods from './kyubi/pods'
import replicaSets from './kyubi/replica-sets'
import services from './kyubi/services'

const initialState = {
  profile: { ...profile.state },
  outputPresets: { ...outputPresets.state },
  jobTemplates: { ...jobTemplates.state },
  jobs: { ...jobs.state },
  projects: { ...projects.state },
  cdn: { ...cdn.state },
  requestPolicies: { ...requestPolicies.state },
  cachePolicies: { ...cachePolicies.state },
  imagePolicies: { ...imagePolicies.state },
  roles: { ...roles.state },
  analytics: { ...analytics.state },
  organization: { ...organization.state },
  payments: { ...payments.state },
  storageSettings: { ...storageSettings.state },
  buckets: { ...buckets.state },
  bucketsCors: { ...bucketsCors.state },
  objects: { ...objects.state },
  storageKeys: { ...storageKeys.state },
  drm: { ...drm.state },
  apiKeys: { ...apiKeys.state },
  permissions: { ...permissions.state },
  users: { ...users.state },
  encoderAnalytics: { ...encoderAnalytics.state },
  liveEncoder: { ...liveEncoder.state },
  liveHubs: { ...liveHubs.state },
  restreams: { ...restreams.state },
  databases: { ...databases.state },
  alerts: { ...alerts.state },
  providers: { ...providers.state },
  healthchecks: { ...healthchecks.state },
  healthcheckLogs: { ...healthcheckLogs.state },
  observability: { ...observability.state },
  compute: { ...compute.state },
  firewall: { ...firewall.state },
  vpc: { ...vpc.state },
  sshKeys: { ...sshKeys.state },
  kyubi: { ...kyubi.state },
  lifecycle: { ...lifecycle.state },
  multiparts: { ...multiparts.state },
  storageLens: { ...storageLens.state },
  nodes: { ...nodes.state },
  captianServices: { ...captianServices.state },
  // v2
  externalAccount: { ...externalAccount.state },
  accountBuckets: { ...accountBuckets.state },
  accountBucketsCors: { ...accountBucketsCors.state },
  accountObjects: { ...accountObjects.state },
  accountMultiparts: { ...accountMultiparts.state },
  accountUploading: { ...accountUploading.state },
  accountLifecycle: { ...accountLifecycle.state },
  storageLensV2: { ...storageLensV2.state },
  storageAnalytics: { ...storageAnalytics.state },
}

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    app,
    appConfig,
    verticalMenu,
    profile,
    outputPresets,
    jobTemplates,
    jobs,
    projects,
    cdn,
    requestPolicies,
    cachePolicies,
    imagePolicies,
    roles,
    analytics,
    organization,
    payments,
    storageSettings,
    buckets,
    bucketsCors,
    objects,
    storageKeys,
    drm,
    apiKeys,
    permissions,
    users,
    encoderAnalytics,
    liveEncoder,
    liveHubs,
    restreams,
    databases,
    alerts,
    providers,
    healthchecks,
    healthcheckLogs,
    observability,
    compute,
    firewall,
    vpc,
    sshKeys,
    kyubi,
    deployments,
    ingress,
    pods,
    replicaSets,
    services,
    uploading,
    lifecycle,
    multiparts,
    storageLens,
    nodes,
    captianServices,
    // v2 storage
    externalAccount,
    accountBuckets,
    accountObjects,
    accountMultiparts,
    accountUploading,
    accountBucketsCors,
    accountLifecycle,
    storageLensV2,
    storageAnalytics,
  },
  mutations: {
    RESET_STATE(state) {
      Object.keys(state).forEach(key => {
        if (key !== 'uploading') {
          Object.assign(state[key], initialState[key])
        }
      })
    },
  },
  strict: process.env.DEV,
})
